const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const {
	SwitchSetModal: SwitchSetModalContent,
} = require("../util/components/SwitchSetModal");
const {ConfirmRestartSet} = require("../util/components/ConfirmRestartSet");
const TeacherModal = require("./TeacherModal");

module.exports = createReactClass({
	displayName: "SwitchSetModal",

	propTypes: {
		onClose: PT.func.isRequired,
		result: PT.object.isRequired,
		block: PT.object,
		labBlock: PT.object,
		styleType: PT.string.isRequired,
		isRestartSet: PT.bool,
		onRequestSet: PT.func.isRequired,
	},

	goToSet: function(opts) {
		this.props.onRequestSet(opts);
		this.props.onClose();
	},

	renderSwitch: function() {
		const {result, block, onClose} = this.props;

		const buttonTexts = ["Okay"];
		const buttonClickHandlers = [onClose];
		const buttonDisabled = [];

		const blockIsGenerated = block.model.isGenerated;

		const totalSets = blockIsGenerated ? 3 : block.model.numSets;
		if (totalSets > 1 || !result.isCurrentSet) {
			_.range(1, totalSets + 1).forEach((setNum, ind) => {
				buttonTexts[ind] = "Set " + setNum;
				buttonClickHandlers[ind] = () => this.goToSet({setNumber: setNum});
				buttonDisabled[ind] =
					(result.isCurrentSet || blockIsGenerated) &&
					result.setNumber === setNum;
			});
		}

		const size = blockIsGenerated ? "large" : null;

		return (
			<TeacherModal
				onClose={onClose}
				buttonTexts={buttonTexts}
				buttonClickHandlers={buttonClickHandlers}
				buttonDisabled={buttonDisabled}
				size={size}
			>
				<SwitchSetModalContent
					result={result}
					totalSets={totalSets}
					isGenerated={blockIsGenerated}
				/>
			</TeacherModal>
		);
	},

	renderRestart: function() {
		const {result, block, onClose} = this.props;
		let buttonTexts = ["Okay"];
		let buttonClickHandlers = [onClose];
		const isGenerated = _.get(block, "model.isGenerated");
		if (isGenerated || result.canRestart) {
			buttonTexts = ["Restart", "Cancel"];
			const restartInfo = {isRestartSet: true};
			if (isGenerated) {
				restartInfo.setNumber = result.setNumber;
			} else {
				restartInfo.originalSetID = result.originalSetID;
			}
			buttonClickHandlers = [() => this.goToSet(restartInfo), onClose];
		}

		return (
			<TeacherModal
				onClose={onClose}
				buttonTexts={buttonTexts}
				buttonClickHandlers={buttonClickHandlers}
			>
				<ConfirmRestartSet result={result} />
			</TeacherModal>
		);
	},

	render: function() {
		if (this.props.isRestartSet) {
			return this.renderRestart();
		} else {
			return this.renderSwitch();
		}
	},
});
